// extracted by mini-css-extract-plugin
export default {"root":"FNxDEuFs","feeRow":"oFipfIsC","feeLabel":"XGxkXVsT","feeAmount":"CzcbgtIE"};